import React from 'react';
import { useTranslation } from 'react-i18next';

const EconomicalTariffUsageHeader = () => {
  // translations
  const t = useTranslation("economicalTariff\\economicalTariff").t;

  return (
    <div className="d-none d-lg-block px-3 mb-2 text-muted font-weight-bold">
       <div className="row no-gutters align-items-end">
        <div className="col-lg-3">
          {t("economicalTariffUsage.placeOfDelivery")}
        </div>
        <div className="col-lg-5 px-lg-3 text-lg-center">
          {t("economicalTariffUsage.usedFor")}
        </div>
        <div className="col-lg-2 text-lg-center">
          {t("economicalTariffUsage.paymentIdentification")}
        </div>
        <div className="col-lg-2 text-right">
          {t("economicalTariffUsage.amount")}
        </div>
      </div>
    </div>
  )
}

export default EconomicalTariffUsageHeader;